<template>
  <main class="payment-page" role="main">
    <div class="payment-iframe-container" v-if="!has_error">
      <form
        ref="form"
        id="paymentForm"
        target="iframe"
        method="post"
        action="https://secure.paygate.co.za/payweb3/process.trans"
        sandbox="allow-top-navigation allow-scripts allow-forms"
      >
        <input type="hidden" name="CHECKSUM" v-model="CHECKSUM">
        <input type="hidden" name="PAY_REQUEST_ID" v-model="PAY_REQUEST_ID">
      </form>
      <iframe name="iframe"></iframe>
    </div>
    <div class="row" v-if="has_response">
      <div class="col-sm-12 col-md-6 col-lg-5">
        <div class="container">
          <div class="error" v-if="!has_error && payment_type == 'debit_order'">
            <h1 class="section-title">{{ message }}</h1>
          </div>
          <div class="error" v-if="has_error">
            <h1 class="section-title">{{ message }}</h1>
            <p class="text-normal">Error processing payment, please contact support for further assitance.</p>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        >
      </div>
    </div>
  </main>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import store from "@/store";
import { CART_RESET } from "@/store/actions.type";

export default {
  name: "payment",
  components: {},
  data: function() {
    return {
      is_loading: false,
      has_error: false,
      has_response: false,
      message: null,
      source: "https://secure.paygate.co.za/payweb3/process.trans",
      CHECKSUM: false,
      PAY_REQUEST_ID: false,
      orders: false,
      payment_type: "credit_card"
    };
  },
  created() {
    var self = this;
    self.payment_type = self.$attrs.payment_type;    
    switch (self.payment_type) {
      case "debit_order":
        self.orders = self.$route.params.orders;
        break;
      case "credit_card_manage":        
        self.$log.debug("credit_card_manage created", self.$attrs);
        self.CHECKSUM = self.$attrs.CHECKSUM;
        self.PAY_REQUEST_ID = self.$attrs.PAY_REQUEST_ID;        
        break;
      default:
        self.$log.debug("credit_card created", self.PAY_REQUEST_ID);
        self.CHECKSUM = self.$route.params.CHECKSUM;
        self.PAY_REQUEST_ID = self.$route.params.PAY_REQUEST_ID;
        break;
    }
  },
  mounted() {
    var self = this;
    self.has_response = false;
    EventBus.$emit("global_loading", { is_loading: false });
    self.$log.debug("payment_type mounted", self.payment_type);
    switch (self.payment_type) {
      case "debit_order":
        self.orders = self.$route.params.orders;
        self.message = "Success";
        self.has_response = true;
        self.has_error = false;
        store.dispatch(CART_RESET);
        window.location = "/backend.html";
        break;
      default:
        self.$log.debug("credit_card mounted", self.PAY_REQUEST_ID);
        if (!self.CHECKSUM || !self.PAY_REQUEST_ID) {
          self.has_error = true;
          self.message =
            // "Error processing payment, please contact support for further assitance.";
             "Error processing payment";
            
        } else {
          self.$refs.form.submit();
        }
        break;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
